import React from 'react'

import leftbarStyles from './leftbar.module.scss'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Image from 'gatsby-image'

const LeftBar = () => {
    const data = useStaticQuery(graphql`

query {
    file(relativePath: {eq: "avatar.png"}) {
        childImageSharp {
            fluid (maxWidth: 125, maxHeight: 125) {
                ...GatsbyImageSharpFluid
            }
            fixed (width: 125, height: 125) {
                ...GatsbyImageSharpFixed
            }
        }
    }
}
`)
    return (
        <div className={leftbarStyles.leftbar}>
            <Image fixed={data.file.childImageSharp.fixed} alt="Avtar image" className={leftbarStyles.avatar} />
            <h1>Kuramoto Taiki</h1>
            <ul className={leftbarStyles.nav}>
                <li className={leftbarStyles.item}>
                    <Link className={leftbarStyles.item} to="/">Home</Link>
                </li>
                <li className={leftbarStyles.item}>
                    <Link className={leftbarStyles.item} to="/blog">Blog</Link>
                </li>
                <li className={leftbarStyles.item}>
                    <Link className={leftbarStyles.item} to="/tags">Tags</Link>
                </li>
            </ul>
        </div>
    )
}

export default LeftBar